const isHexColor = (hexColor) =>
  /^#?([a-fA-F0-9]{3,4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$/.test(hexColor);

export default isHexColor;
